import { useState } from 'react';

export default function useToken() {

    const getToken = () => {
        return sessionStorage.getItem('token');
    };

    const [token, setToken] = useState(getToken());

    const saveToken = (token=null) => {
        if (token) {
            sessionStorage.setItem("token", token);
        } else {
            sessionStorage.removeItem("token");
        }
        setToken(token);
    };

    return {
        setToken: saveToken,
        token
    }

}